import * as angular from "angular";
import {IController} from "angular";

export class SchedulingProjectVisitPlansViewComponent implements IController {

  public currentNavItem: string;

  /* @ngInject */
  constructor(private $state) {
  }

  $onInit() {
    if (this.$state.includes('scheduling-project.visit-plans.templates')) {
      this.currentNavItem = 'scheduling-project.visit-plans.templates';
    } else if (this.$state.includes('scheduling-project.visit-plans.reports')) {
      this.currentNavItem = 'scheduling-project.visit-plans.reports';
    } else {
      this.currentNavItem = 'scheduling-project.visit-plans.table';
    }
  }
}

angular
  .module('bringoz.admin.scheduling-project')
  .component('schedulingProjectVisitPlanView', {
    template: require('./scheduling-project-visit-plans-view.html').default,
    controller: SchedulingProjectVisitPlansViewComponent
  });
